import { useQuery } from '@tanstack/react-query'

import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { getSubscriptionStatus } from 'src/services/subscriptionApi'
import { SubscriptionStatusResponse } from 'src/services/subscriptionApi/interfaces/subscriptionApi.interface'

export const useGetSubscriptionStatusQuery = () => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery<SubscriptionStatusResponse>({
    enabled: !!sessionId,
    queryFn: getSubscriptionStatus,
    queryKey: [QueryKey.GET_SUBSCRIPTION_STATUS],
  })
}
